import { Form, Input, Select } from 'antd';
import React from 'react';
import { IdefaultVendor } from './Vendor';

interface VendorTransmissionInfoCollapsibleProps {
  vendorDetails: IdefaultVendor;
  onChange: (key: string, value: any) => void;
}

type FieldType = {
  transmission_power?: number;
  transmitters?: string;
  eirp_capability?: number;
  antenna_beamwidth?: number;
  vertical_beamwidth?: number;
  front_to_back_ratio?: number;
  feeder_loss?: number;
  antenna_model?: string;
  antenna_gain?: number;
  antenna_pattern?: string;
};

const VendorTransmissionInfoCollapsible: React.FC<VendorTransmissionInfoCollapsibleProps> = ({ vendorDetails, onChange }) => {
  const handleChange = (key: string, value: any) => {
    onChange(key, value);
  };

  return (
    <Form
      name="basic"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 24 }}
      initialValues={{
        transmission_power: vendorDetails.transmission_power,
        transmitters: vendorDetails.transmitters,
        eirp_capability: vendorDetails.eirp_capability,
        antenna_beamwidth: vendorDetails.antenna_beamwidth,
        vertical_beamwidth: vendorDetails.vertical_beamwidth,
        front_to_back_ratio: vendorDetails.front_to_back_ratio,
        feeder_loss: vendorDetails.feeder_loss,
        antenna_model: vendorDetails.antenna_model,
        antenna_gain: vendorDetails.antenna_gain,
        antenna_pattern: vendorDetails.antenna_pattern,
      }}
      autoComplete="off">
      <Form.Item<FieldType> label="Antenna Model" name="antenna_model" rules={[{ required: false }]}>
        <Input onChange={(e: any) => handleChange('antenna_model', e.target.value)} />
      </Form.Item>
      <Form.Item<FieldType> label="Antenna Pattern" name="antenna_pattern" rules={[{ required: false }]}>
        <Input onChange={(e: any) => handleChange('antenna_pattern', e.target.value)} />
      </Form.Item>
      <Form.Item<FieldType> label="Transmission Power" name="transmission_power" rules={[{ required: false }]}>
        <Input type="number" addonAfter="Watts" onChange={(e: any) => handleChange('transmission_power', e.target.value)} />
      </Form.Item>
      <Form.Item<FieldType> label="No. of Transmitters" name="transmitters" rules={[{ required: false }]}>
        <Select
          getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
          }}
          onChange={(value: any) => handleChange('transmitters', value)}
          value={vendorDetails.transmitters}
          options={[
            { label: '1', value: '1' },
            { label: '2', value: '2' },
            { label: '3', value: '3' },
            { label: '4', value: '4' },
          ]}
        />
      </Form.Item>
      <Form.Item<FieldType> label="EIRP Capability" name="eirp_capability" rules={[{ required: false }]}>
        <Input type="number" addonAfter="dBm" onChange={(e: any) => handleChange('eirp_capability', e.target.value)} />
      </Form.Item>
      <Form.Item<FieldType> label="Horizontal Beamwidth" name="antenna_beamwidth" rules={[{ required: false }]}>
        <Input type="number" max={360} min={0} addonAfter="Degrees" onChange={(e: any) => handleChange('antenna_beamwidth', e.target.value)} />
      </Form.Item>
      <Form.Item<FieldType> label="Vertical Beamwidth" name="vertical_beamwidth" rules={[{ required: false }]}>
        <Input type="number" max={360} min={0} addonAfter="Degrees" onChange={(e: any) => handleChange('vertical_beamwidth', e.target.value)} />
      </Form.Item>
      <Form.Item<FieldType> label="Front to Back Ratio" name="front_to_back_ratio" rules={[{ required: false }]}>
        <Input type="number" addonAfter="dB" onChange={(e: any) => handleChange('front_to_back_ratio', e.target.value)} />
      </Form.Item>
      <Form.Item<FieldType> label="Feeder Loss" name="feeder_loss" rules={[{ required: false }]}>
        <Input type="number" addonAfter="dB" onChange={(e: any) => handleChange('feeder_loss', e.target.value)} />
      </Form.Item>
      <Form.Item<FieldType> label="Antenna Gain" name="antenna_gain" rules={[{ required: false }]}>
        <Input type="number" addonAfter="dBi" onChange={(e: any) => handleChange('antenna_gain', e.target.value)} />
      </Form.Item>
    </Form>
  );
};

export default VendorTransmissionInfoCollapsible;
